import { useTranslation } from "react-i18next";
import { Menu, Bell, Search } from "lucide-react";
import LanguageSelector from "../LanguageSelector";
import { ThemeToggle } from "../theme-toggle";

const LayoutHeader = ({ setSidebarOpen, menuItems, pathname, formatFullDateTime, user, userAccessLevel, logout }) => {
  const { t } = useTranslation();

  // Resolve the most specific title for the current route: prefer a matching
  // sub-item (e.g. "Employés") over its parent group (e.g. "Collaborateurs").
  const resolvePageTitle = () => {
    for (const item of menuItems) {
      if (item.path === pathname) return item.title;
      const sub = item.items?.find((s) => s.path === pathname);
      if (sub) return sub.title;
    }
    return t('sidebar.defaultTitle');
  };
  const pageTitle = resolvePageTitle();

  return (
    <header className="flex items-center justify-between px-6 flex-shrink-0"
      style={{ height: "56px", backgroundColor: "var(--lm-canvas)", borderBottom: "1px solid var(--lm-border)" }}>

      <div className="flex items-center gap-4">
        <button
          className="flex lg:hidden items-center justify-center w-8 h-8 rounded-lg transition-colors"
          style={{ color: "var(--lm-ink-3)" }}
          onClick={() => setSidebarOpen(true)}
          onMouseEnter={e => (e.currentTarget.style.backgroundColor = "var(--lm-s2)")}
          onMouseLeave={e => (e.currentTarget.style.backgroundColor = "transparent")}
        >
          <Menu className="w-4 h-4" />
        </button>
        <div className="hidden lg:flex items-center gap-3">
          <h2 className="text-sm font-semibold" style={{ color: "var(--lm-ink)", letterSpacing: "-0.2px" }}>{pageTitle}</h2>
          <div style={{ width: "1px", height: "14px", backgroundColor: "var(--lm-border)" }} />
          <p className="text-xs" style={{ color: "var(--lm-ink-3)", fontVariantNumeric: "tabular-nums", letterSpacing: "0.2px" }}>{formatFullDateTime()}</p>
        </div>
      </div>

      <div className="flex items-center gap-1">
        <button className="flex items-center justify-center w-8 h-8 rounded-lg transition-colors" style={{ color: "var(--lm-ink-3)" }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = "var(--lm-s2)"; e.currentTarget.style.color = "var(--lm-ink-2)"; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = "transparent"; e.currentTarget.style.color = "var(--lm-ink-3)"; }}>
          <Search className="w-4 h-4" />
        </button>
        <button className="flex items-center justify-center w-8 h-8 rounded-lg transition-colors" style={{ color: "var(--lm-ink-3)" }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = "var(--lm-s2)"; e.currentTarget.style.color = "var(--lm-ink-2)"; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = "transparent"; e.currentTarget.style.color = "var(--lm-ink-3)"; }}>
          <Bell className="w-4 h-4" />
        </button>
        <LanguageSelector variant="minimal" />
        <ThemeToggle />
      </div>
    </header>
  );
};

export default LayoutHeader;
